__turbopack_context__.v({
  "policy_extras_styles": "TigryW_policy_extras_styles",
});
